// Thin wrapper around window.dataLayer for GTM.
// Uses GA4-standard event names where applicable so a single GTM tag
// (GA4 Configuration + GA4 Event) maps to Google Analytics out-of-the-box.

const push = (payload) => {
  try {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch {
    /* never block UX on analytics */
  }
};

// --- Booking funnel (GA4 ecommerce shape) ---

export const trackViewItem = (apt) => {
  if (!apt) return;
  push({
    event: "view_item",
    ecommerce: {
      currency: "EUR",
      value: apt.price_per_night || 0,
      items: [
        {
          item_id: apt.id,
          item_name: apt.name_en || apt.id,
          price: apt.price_per_night || 0,
        },
      ],
    },
  });
};

export const trackQuoteCalculated = ({ apt, quote }) => {
  if (!quote || !apt) return;
  push({
    event: "quote_calculated",
    ecommerce: {
      currency: quote.currency || "EUR",
      value: quote.total,
      items: [
        {
          item_id: apt.id,
          item_name: apt.name_en || apt.id,
          price: quote.total,
          quantity: quote.nights,
        },
      ],
    },
    nights: quote.nights,
    short_stay_surcharge: quote.short_stay_surcharge || 0,
  });
};

export const trackBeginCheckout = ({ apt, quote, bookingId }) => {
  if (!quote || !apt) return;
  push({
    event: "begin_checkout",
    ecommerce: {
      currency: quote.currency || "EUR",
      value: quote.total,
      transaction_id: bookingId,
      items: [
        {
          item_id: apt.id,
          item_name: apt.name_en || apt.id,
          price: quote.total,
          quantity: quote.nights,
        },
      ],
    },
  });
};

export const trackPurchase = ({ booking }) => {
  if (!booking) return;
  push({
    event: "purchase",
    ecommerce: {
      transaction_id: booking.id,
      currency: booking.currency || "EUR",
      value: booking.total_price,
      items: [
        {
          item_id: booking.apartment_id,
          item_name: booking.apartment_id,
          price: booking.total_price,
          quantity: booking.nights,
        },
      ],
    },
  });
};

// --- Engagement events ---

export const trackLanguageChange = (to) =>
  push({ event: "language_changed", language: to });

export const trackContactSubmit = () =>
  push({ event: "contact_form_submitted" });

export const trackGuideOpened = (topic) =>
  push({ event: "guide_topic_opened", topic });

export const trackWhatsappClick = () =>
  push({ event: "whatsapp_click" });

export const trackPhoneClick = () =>
  push({ event: "phone_click" });
